<po-page-default class="users-admin-shell" p-title="Gestão de usuários">
  <po-tabs>
    <po-tab *ngFor="let tab of tabs" [p-label]="tab.label" [p-active]="isActive(tab)" (p-click)="navigate(tab)"></po-tab>
  </po-tabs>

  <div class="users-admin-outlet">
    <router-outlet></router-outlet>
  </div>
</po-page-default>
